import React from 'react';
import Wrapper from './Wrapper';
import logo from '../../assets/images/logo.svg';

export default function Footer() {
    return (
        <footer className="bg-gray-200 py-8">
            <Wrapper>
                <a href="https://www.airproducts.co.uk"><img src={logo} alt="The Air Products logo" /></a>
                <hr className="mt-6 mb-4 border-gray-800" />
                <nav>
                    <ul className="lg:flex lg:items-center lg:justify-start">
                        <li className="text-sm leading-none hover:underline mb-3 lg:mb-0 lg:pr-2 lg:mr-2 lg:border-r lg:border-gray-800"><a href="https://www.airproducts.co.uk/legal-notice ">Legal Notice</a></li>
                        <li className="text-sm leading-none hover:underline mb-3 lg:mb-0 lg:pr-2 lg:mr-2 lg:border-r lg:border-gray-800"><a href="https://www.airproducts.co.uk/privacy-notice ">Privacy Notice</a></li>
                        <li className="text-sm leading-none mb-3 lg:mb-0 lg:pr-2 lg:mr-2 lg:border-r lg:border-gray-800"><p>Copyright &copy; {new Date().getFullYear()} Air Products and Chemicals, Inc.</p></li>
                        <li className="text-sm leading-none hover:underline"><a href="https://www.airproducts.co.uk/" target="_blank" rel="noopener noreferrer">www.airproducts.co.uk</a> <i className="fas fa-long-arrow-alt-right"></i></li>
                    </ul>
                </nav>
            </Wrapper>
        </footer>
    );
}